module.exports = __webpack_public_path__ + "img/jxw.931519d0.png";